import ScrollMagic from 'scrollmagic'
import TweenMax from 'gsap/TweenMax'
import TimelineMax from 'gsap/TimelineMax'
import 'scrollmagic/scrollmagic/minified/plugins/animation.gsap.min'
import { animateScene, bindPromoButtons } from './utils'
import './promo-motion'

const controller = new ScrollMagic.Controller()

window.addEventListener('DOMContentLoaded', e => {
    bindPromoButtons()
})


function init() {
    const animated = [].map.call(document.querySelectorAll('[data-animated]'), element => element);
    animated.forEach(element => animateScene(controller, element, element))

    const scenes = [].map.call(document.querySelectorAll('[data-parallax-scene]'), element => element)

    scenes.forEach(sceneEl => {
        const vh = window.innerHeight
        const height = sceneEl.offsetHeight + vh
        const elements = [].map.call(sceneEl.querySelectorAll('[data-parallax-element]'), element => element)
        const scene = new ScrollMagic.Scene({ triggerElement: sceneEl, duration: height, triggerHook: 1 })
        const tweens = []
        
        scene.addTo(controller)

        elements.forEach(element => {
            const offset = Number(element.getAttribute('data-offset'))
            const dir = element.getAttribute('data-direction')
            tweens.push(TweenMax.to(element, 1, { [dir]: offset, ease: Power0.easeNone }))
        })
        scene.setTween(tweens)
    })
}

// function addParallax(element) {
//     new ScrollMagic.Scene(controller)
// }


window.addEventListener('load', () => {
    init()
    // const scene = new ScrollMagic.Scene({
    //     triggerElement: '.body',
    //     duration: window.innerHeight,
    //     triggerHook: 0.5
    // })
    //     .addTo(controller)
    //     .setTween([
    //         TweenMax.to(el, 1, { y: 500 })
    //     ])

})

export default {}